module.exports = new Promise(async (resolve, reject) => {
  /* ─────────── 1. look up the URL ─────────── */
  const urlGetter = window.__mf_getUrl
  const remoteUrl = urlGetter && urlGetter('workspace_mgmt')

  if (!remoteUrl) {
    reject(new Error('No URL configured for remote "workspace_mgmt"'))
    return
  }
  if (!/^(https?):\/\//.test(remoteUrl)) {
    reject(new Error('Invalid URL for remote "workspace_mgmt": ' + remoteUrl))
    return
  }

  /* ─────────── 2. quick HEAD pre-flight (3s) ─────────── */
  const fetchWithTimeout = (url, timeoutMs = 3000) =>
    new Promise((res, rej) => {
      const t = setTimeout(() => rej(new Error('Timeout while checking ' + url)), timeoutMs)
      fetch(url, { method: 'HEAD' })
        .then(r => { clearTimeout(t); res(r) })
        .catch(e => { clearTimeout(t); rej(e) })
    })

  try {
    const head = await fetchWithTimeout(remoteUrl)
    if (!head.ok) {
      reject(new Error('Remote "workspace_mgmt" responded with HTTP ' + head.status))
      return
    }
  } catch (err) {
    reject(new Error('Failed to fetch remote "workspace_mgmt": ' + err.message))
    return
  }

  /* ─────────── 3· already loaded? ─────────── */
  if (window['workspace_mgmt']) {
    resolve(window['workspace_mgmt'])
    return
  }

  /* ─────────── 4· inject <script> and init ─────────── */
  const script = document.createElement('script')
  script.src = remoteUrl
  script.type = 'text/javascript'
  script.async = true

  script.onload  = () => resolve(window['workspace_mgmt'])

  script.onerror = () => {
    script.remove()
    reject(new Error('Failed to load remote "workspace_mgmt" from ' + remoteUrl))
  }

  document.head.appendChild(script)
});